/*
 * Copyright (c) 2022 E-WIND - Thais Watanabe.
 * All rights reserved.
 */
import React from "react";
import { Authenticator } from "@aws-amplify/ui-react";
import { Amplify, I18n } from "aws-amplify";
import { translations } from "@aws-amplify/ui";
import "@aws-amplify/ui-react/styles.css";

import { awsmobile } from "src/aws-exports";
import { HomePage } from "src/Home";
import "src/assets/css/App.css";

import Header from "./components/login/Header";
import Footer from "./components/login/Footer";
import SignInHeader from "./components/login/SignInHeader";

I18n.putVocabularies(translations);
I18n.setLanguage("ja");

I18n.putVocabularies({
  ja: {
    'Enter your Username': 'ユーザー名を入力してください',
    'Enter your Password': "パスワードを入力してください",
  },
});

Amplify.configure(awsmobile);

const components = {
  Header() {
    return <Header />;
  },

  Footer() {
    return <Footer />;
  },

  SignIn: {
    Header() {
      return <SignInHeader />;
    },
  },
};

/**
 * The App Component
 *
 * @author Thais Watanabe
 */
export default function App() {
  return (
    <div className="bg-teal-50 h-screen">
      <Authenticator components={components}>
        {({ user }) => user && <HomePage />}
      </Authenticator>
    </div>
  );
}
